/** Origins allowed to post AUTH_COMPLETE (SSO popup/breakout tab). */
export function isTrustedAuthOrigin(origin: string): boolean {
  if (!origin) return false;
  if (origin === window.location.origin) return true;
  try {
    const { protocol, hostname } = new URL(origin);
    if (protocol !== "https:") return false;
    return [".lovable.app", ".lovableproject.com", ".lovable.dev"].some((s) => hostname.endsWith(s));
  } catch {
    return false;
  }
}
